import React from 'react';
import { Link } from 'react-router-dom';
import { HEAD_DOCTOR_COPY } from '../headDoctorCopy';
import { fmtSynthesisNumber } from './synthesisTableModel';

const COPY = HEAD_DOCTOR_COPY.REPORTS;

export default function SynthesisActivityTable({
  groups = [],
  days = 1,
  periodLabel = '',
  loading = false,
  title = COPY.SYNTHESE_TABLE_TITLE,
  description,
  emptyLabel = COPY.LOADING,
  className = ''
}) {
  const desc =
    description ??
    (typeof COPY.SYNTHESE_TABLE_DESC === 'function'
      ? COPY.SYNTHESE_TABLE_DESC(days, periodLabel || '')
      : '');

  return (
    <div className={`hd-synthese-table-card${className ? ` ${className}` : ''}`}>
      <div className="hd-synthese-table-card__head">
        <div className="hd-synthese-table-card__head-main">
          <h3 className="hd-synthese-table-card__title">{title}</h3>
          {desc ? <p className="hd-synthese-table-card__desc mb-0">{desc}</p> : null}
        </div>
        <span className="hd-synthese-table-card__days">{Number(days || 0).toLocaleString('fr-FR')} j</span>
      </div>

      <div className="hd-synthese-table-wrap">
        <table className="hd-synthese-table">
          <thead>
            <tr>
              <th>{COPY.SYNTHESE_COL_INDICATOR}</th>
              <th className="text-end">{COPY.SYNTHESE_COL_TOTAL}</th>
              <th className="text-end">{COPY.SYNTHESE_COL_AVG_DAY}</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr>
                <td colSpan={3} className="hd-synthese-table__empty">
                  <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden />
                  {emptyLabel}
                </td>
              </tr>
            ) : groups.length === 0 ? (
              <tr>
                <td colSpan={3} className="hd-synthese-table__empty">
                  Aucune donnée sur la période.
                </td>
              </tr>
            ) : (
              groups.map((group) => (
                <React.Fragment key={group.section}>
                  <tr className={`hd-synthese-table__section hd-synthese-table__section--${group.tone}`}>
                    <td colSpan={3}>
                      <span className="hd-synthese-table__section-label">{group.section}</span>
                    </td>
                  </tr>
                  {group.rows.map((row) => (
                    <tr
                      key={row.key}
                      className={`hd-synthese-table__row${row.indent ? ' hd-synthese-table__indent' : ''}${
                        Number(row.total) > 0 ? ' has-value' : ''
                      }`}
                    >
                      <td>
                        {row.link ? (
                          <Link to={row.link} className="hd-synthese-table__link">
                            {row.label}
                          </Link>
                        ) : (
                          <span className="hd-synthese-table__label">{row.label}</span>
                        )}
                      </td>
                      <td className="text-end">
                        <span className="hd-synthese-table__num">{fmtSynthesisNumber(row.total)}</span>
                      </td>
                      <td className="text-end">
                        <span className="hd-synthese-table__avg">{row.avg}</span>
                      </td>
                    </tr>
                  ))}
                </React.Fragment>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
